import { render } from "./TinyMceEditor.vue?vue&type=template&id=3c30b87c"
import script from "./TinyMceEditor.vue?vue&type=script&lang=js"
export * from "./TinyMceEditor.vue?vue&type=script&lang=js"

import "./TinyMceEditor.vue?vue&type=style&index=0&id=3c30b87c&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__